/**
 * @hidden
 * @deprecated
 */
export var created = 'create';
/**
 * @hidden
 * @deprecated
 */
export var destroyed = 'destroy';
/**
 * @hidden
 * @deprecated
 */
export var tableclass = 'tableclass';
/**
 * @hidden
 * @deprecated
 */
export var load = 'load';
/**
 * Specifies Rich Text Editor internal events
 */
/**
 * @hidden
 * @deprecated
 */
export var initialLoad = 'initial-load';
/**
 * @hidden
 * @deprecated
 */
export var contentChanged = 'content-changed';
/**
 * @hidden
 * @deprecated
 */
export var initialEnd = 'initial-end';
/**
 * @hidden
 * @deprecated
 */
export var iframeMouseDown = 'iframe-click';
/**
 * @hidden
 * @deprecated
 */
export var destroy = 'destroy';
/**
 * @hidden
 * @deprecated
 */
export var toolbarClick = 'toolbarClick';
/**
 * @hidden
 * @deprecated
 */
export var toolbarRefresh = 'toolbar-refresh';
/**
 * @hidden
 * @deprecated
 */
export var slashMenuOpening = 'slash-menu-opening';
/**
 * @hidden
 * @deprecated
 */
export var refreshBegin = 'refresh-begin';
/**
 * @hidden
 * @deprecated
 */
export var toolbarUpdated = 'toolbar-updated';
/**
 * @hidden
 * @deprecated
 */
export var bindOnEnd = 'bind-on-end';
/**
 * @hidden
 * @deprecated
 */
export var htmlToolbarClick = 'html-toolbar-click';
/**
 * @hidden
 * @deprecated
 */
export var markdownToolbarClick = 'markdown-toolbar-click';
/**
 * @hidden
 * @deprecated
 */
export var modelChanged = 'model-changed';
/**
 * @hidden
 * @deprecated
 */
export var tableModulekeyUp = 'tableModulekeyUp';
/**
 * @hidden
 * @deprecated
 */
export var keyUp = 'keyUp';
/**
 * @hidden
 * @deprecated
 */
export var keyDown = 'keyDown';
/**
 * @hidden
 * @deprecated
 */
export var onImport = 'onImport';
/**
 * @hidden
 * @deprecated
 */
export var onExport = 'onExport';
/**
 * @hidden
 * @deprecated
 */
export var onCodeBlock = 'onCodeBlock';
/**
 * @hidden
 * @deprecated
 */
export var mouseUp = 'mouseUp';
/**
 * @hidden
 * @deprecated
 */
export var toolbarCreated = 'toolbarCreated';
/**
 * @hidden
 * @deprecated
 */
export var toolbarRenderComplete = 'toolbarRenderComplete';
/**
 * @hidden
 * @deprecated
 */
export var enableFullScreen = 'enableFullScreen';
/**
 * @hidden
 * @deprecated
 */
export var disableFullScreen = 'disableFullScreen';
/**
 * @private
 */
export var getWebMcpTools = 'getWebMcpTools';
/**
 * @private
 */
export var registerWebMcpTools = 'registerWebMcpTools';
/**
 * @hidden
 * @deprecated
 */
export var dropDownSelect = 'dropDownSelect';
/**
 * @hidden
 * @deprecated
 */
export var beforeDropDownItemRender = 'beforeDropDownItemRender';
/**
 * @hidden
 * @deprecated
 */
export var execCommandCallBack = 'execCommandCallBack';
/**
 * @hidden
 * @deprecated
 */
export var imageToolbarAction = 'image-toolbar-action';
/**
 * @hidden
 * @deprecated
 */
export var audioToolbarAction = 'audio-toolbar-action';
/**
 * @hidden
 * @deprecated
 */
export var videoToolbarAction = 'video-toolbar-action';
/**
 * @hidden
 * @deprecated
 */
export var linkToolbarAction = 'link-toolbar-action';
/**
 * @hidden
 * @deprecated
 */
export var windowResize = 'resize';
/**
 * @hidden
 * @deprecated
 */
export var resizeStart = 'resizeStart';
/**
 * @hidden
 * @deprecated
 */
export var onResize = 'resizing';
/**
 * @hidden
 * @deprecated
 */
export var resizeStop = 'resizeStop';
/**
 * @hidden
 * @deprecated
 */
export var undo = 'undo';
/**
 * @hidden
 * @deprecated
 */
export var redo = 'redo';
/**
 * @hidden
 * @deprecated
 */
export var insertLink = 'insertLink';
/**
 * @hidden
 * @deprecated
 */
export var unLink = 'unLink';
/**
 * @hidden
 * @deprecated
 */
export var editLink = 'editLink';
/**
 * @hidden
 * @deprecated
 */
export var openLink = 'openLink';
/**
 * @hidden
 * @deprecated
 */
export var actionBegin = 'actionBegin';
/**
 * @hidden
 * @deprecated
 */
export var actionComplete = 'actionComplete';
/**
 * @hidden
 * @deprecated
 */
export var updatedToolbarStatus = 'updatedToolbarStatus';
/**
 * @hidden
 * @deprecated
 */
export var actionSuccess = 'actionSuccess';
/**
 * @hidden
 * @deprecated
 */
export var updateToolbarItem = 'updateToolbarItem';
/**
 * @hidden
 * @deprecated
 */
export var insertImage = 'insertImage';
/**
 * @hidden
 * @deprecated
 */
export var insertAudio = 'insertAudio';
/**
 * @hidden
 * @deprecated
 */
export var insertVideo = 'insertVideo';
/**
 * @hidden
 * @deprecated
 */
export var insertCompleted = 'insertCompleted';
/**
 * @hidden
 * @deprecated
 */
export var imageLeft = 'justifyLeft';
/**
 * @hidden
 * @deprecated
 */
export var imageRight = 'justifyRight';
/**
 * @hidden
 * @deprecated
 */
export var imageCenter = 'justifyCenter';
/**
 * @hidden
 * @deprecated
 */
export var imageBreak = 'break';
/**
 * @hidden
 * @deprecated
 */
export var imageInline = 'inline';
/**
 * @hidden
 * @deprecated
 */
export var imageLink = 'insertImgLink';
/**
 * @hidden
 * @deprecated
 */
export var imageAlt = 'imgAltText';
/**
 * @hidden
 * @deprecated
 */
export var imageDelete = 'delete';
/**
 * @hidden
 * @deprecated
 */
export var audioDelete = 'delete';
/**
 * @hidden
 * @deprecated
 */
export var videoDelete = 'delete';
/**
 * @hidden
 * @deprecated
 */
export var imageCaption = 'caption';
/**
 * @hidden
 * @deprecated
 */
export var imageSize = 'imageSize';
/**
 * @hidden
 * @deprecated
 */
export var videoSize = 'videoSize';
/**
 * @hidden
 * @deprecated
 */
export var sourceCode = 'sourceCode';
/**
 * @hidden
 * @deprecated
 */
export var updateSource = 'updateSource';
/**
 * @hidden
 * @deprecated
 */
export var toolbarOpen = 'toolbarOpen';
/**
 * @hidden
 * @deprecated
 */
export var beforeDropDownOpen = 'beforeDropDownOpen';
/**
 * @hidden
 * @deprecated
 */
export var selectionSave = 'selection-save';
/**
 * @hidden
 * @deprecated
 */
export var selectionRestore = 'selection-restore';
/**
 * @hidden
 * @deprecated
 */
export var expandPopupClick = 'expandPopupClick';
/**
 * @hidden
 * @deprecated
 */
export var count = 'count';
/**
 * @hidden
 * @deprecated
 */
export var contentFocus = 'contentFocus';
/**
 * @hidden
 * @deprecated
 */
export var contentBlur = 'contentBlur';
/**
 * @hidden
 * @deprecated
 */
export var mouseDown = 'mouseDown';
/**
 * @hidden
 * @deprecated
 */
export var sourceCodeMouseDown = 'sourceCodeMouseDown';
/**
 * @hidden
 * @deprecated
 */
export var editAreaClick = 'editAreaClick';
/**
 * @hidden
 * @deprecated
 */
export var scroll = 'scroll';
/**
 * @hidden
 * @deprecated
 */
export var contentscroll = 'contentscroll';
/**
 * @hidden
 * @deprecated
 */
export var colorPickerChanged = 'colorPickerChanged';
/**
 * @hidden
 * @deprecated
 */
export var focusChange = 'focusChange';
/**
 * @hidden
 * @deprecated
 */
export var selectAll = 'selectAll';
/**
 * @hidden
 * @deprecated
 */
export var selectRange = 'selectRange';
/**
 * @hidden
 * @deprecated
 */
export var getSelectedHtml = 'getSelectedHtml';
/**
 * @hidden
 * @deprecated
 */
export var renderInlineToolbar = 'renderInlineToolbar';
/**
 * @hidden
 * @deprecated
 */
export var paste = 'paste-content';
/**
 * @hidden
 * @deprecated
 */
export var videoPaste = 'video-paste-content';
/**
 * @hidden
 * @deprecated
 */
export var audioPaste = 'audio-paste-content';
/**
 * @hidden
 * @deprecated
 */
export var codeBlockPaste = 'code-block-paste-content';
/**
 * @hidden
 * @deprecated
 */
export var codeBlockEnter = 'code-block-enter';
/**
 * @hidden
 * @deprecated
 */
export var imgModule = 'imageModule';
/**
 * @hidden
 * @deprecated
 */
export var rtlMode = 'rtl-mode';
/**
 * @hidden
 * @deprecated
 */
export var createTable = 'createTable';
/**
 * @hidden
 * @deprecated
 */
export var updateProperty = 'updateProperty';
/**
 * @hidden
 * @deprecated
 */
export var docClick = 'docClick';
/**
 * @hidden
 * @deprecated
 */
export var tableToolbarAction = 'table-toolbar-action';
/**
 * @hidden
 * @deprecated
 */
export var checkUndo = 'checkUndoStack';
/**
 * @hidden
 * @deprecated
 */
export var readOnlyMode = 'readOnlyMode';
/**
 * @hidden
 * @deprecated
 */
export var clipBoardCleanup = 'clipBoardCleanup';
/**
 * @hidden
 * @deprecated
 */
export var beforeClipboardWrite = 'beforeClipboardWrite';
/**
 * @hidden
 * @deprecated
 */
export var pasteClean = 'pasteClean';
/**
 * @hidden
 * @deprecated
 */
export var enterHandler = 'enterHandler';
/**
 * @hidden
 * @deprecated
 */
export var beforeDialogOpen = 'beforeDialogOpen';
/**
 * @hidden
 * @deprecated
 */
export var clearDialogObj = 'clearDialogObj';
/**
 * @hidden
 * @deprecated
 */
export var dialogOpen = 'dialogOpen';
/**
 * @hidden
 * @deprecated
 */
export var beforeDialogClose = 'beforeDialogClose';
/**
 * @hidden
 * @deprecated
 */
export var dialogClose = 'dialogClose';
/**
 * @hidden
 * @deprecated
 */
export var beforeQuickToolbarOpen = 'beforeQuickToolbarOpen';
/**
 * @hidden
 * @deprecated
 */
export var quickToolbarOpen = 'quickToolbarOpen';
/**
 * @hidden
 * @deprecated
 */
export var quickToolbarClose = 'quickToolbarClose';
/**
 * @hidden
 * @deprecated
 */
export var popupHide = 'popupHide';
/**
 * @hidden
 * @deprecated
 */
export var imageSelected = 'imageSelected';
/**
 * @hidden
 * @deprecated
 */
export var imageUploading = 'imageUploading';
/**
 * @hidden
 * @deprecated
 */
export var imageUploadSuccess = 'imageUploadSuccess';
/**
 * @hidden
 * @deprecated
 */
export var imageUploadFailed = 'imageUploadFailed';
/**
 * @hidden
 * @deprecated
 */
export var imageRemoving = 'imageRemoving';
/**
 * @hidden
 * @deprecated
 */
export var fileSelected = 'fileSelected';
/**
 * @hidden
 * @deprecated
 */
export var fileUploading = 'fileUploading';
/**
 * @hidden
 * @deprecated
 */
export var fileUploadSuccess = 'fileUploadSuccess';
/**
 * @hidden
 * @deprecated
 */
export var fileUploadFailed = 'fileUploadFailed';
/**
 * @hidden
 * @deprecated
 */
export var fileRemoving = 'fileRemoving';
/**
 * @hidden
 * @deprecated
 */
export var afterImageDelete = 'afterImageDelete';
/**
 * @hidden
 * @deprecated
 */
export var afterMediaDelete = 'afterMediaDelete';
/**
 * @hidden
 * @deprecated
 */
export var drop = 'drop';
/**
 * @hidden
 * @deprecated
 */
export var renderQuickToolbar = 'renderQuickToolbar';
/**
 * @hidden
 * @deprecated
 */
export var xhtmlValidation = 'xhtmlValidation';
/**
 * @hidden
 * @deprecated
 */
export var beforeImageUpload = 'beforeImageUpload';
/**
 * @hidden
 * @deprecated
 */
export var beforeFileUpload = 'beforeFileUpload';
/**
 * @hidden
 * @deprecated
 */
export var resizeInitialized = 'resizeInitialized';
/**
 * @hidden
 * @deprecated
 */
export var renderFileManager = 'renderFileManager';
/**
 * @hidden
 * @deprecated
 */
export var beforeImageDrop = 'beforeImageDrop';
/**
 * @hidden
 * @deprecated
 */
export var beforeMediaDrop = 'beforeMediaDrop';
/**
 * @hidden
 * @deprecated
 */
export var dynamicModule = 'dynamicModule';
/**
 * @hidden
 * @deprecated
 */
export var beforePasteCleanup = 'beforePasteCleanup';
/**
 * @hidden
 * @deprecated
 */
export var afterPasteCleanup = 'afterPasteCleanup';
/**
 * @hidden
 * @deprecated
 */
export var updateTbItemsStatus = 'updateTbItemsStatus';
/**
 * @hidden
 * @deprecated
 */
export var showLinkDialog = 'showLinkDialog';
/**
 * @hidden
 * @deprecated
 */
export var closeLinkDialog = 'closeLinkDialog';
/**
 * @hidden
 * @deprecated
 */
export var showImageDialog = 'showImageDialog';
/**
 * @hidden
 * @deprecated
 */
export var showAudioDialog = 'showAudioDialog';
/**
 * @hidden
 * @deprecated
 */
export var showVideoDialog = 'showVideoDialog';
/**
 * @hidden
 * @deprecated
 */
export var closeImageDialog = 'closeImageDialog';
/**
 * @hidden
 * @deprecated
 */
export var closeAudioDialog = 'closeAudioDialog';
/**
 * @hidden
 * @deprecated
 */
export var closeVideoDialog = 'closeVideoDialog';
/**
 * @hidden
 * @deprecated
 */
export var showTableDialog = 'showTableDialog';
/**
 * @hidden
 * @deprecated
 */
export var closeTableDialog = 'closeTableDialog';
/**
 * @hidden
 * @deprecated
 */
export var bindCssClass = 'bindCssClass';
/**
 * @hidden
 * @deprecated
 */
export var formatPainterClick = 'formatPainterClick';
/**
 * @hidden
 * @deprecated
 */
export var formatPainterDoubleClick = 'formatPainterDoubleClick';
/**
 * @hidden
 * @deprecated
 */
export var emojiPicker = 'emojiPicker';
/**
 * @hidden
 * @deprecated
 */
export var destroyTooltip = 'destroyTooltip';
/**
 * @hidden
 * @deprecated
 */
export var hidePopup = 'hidePopup';
/**
 * @hidden
 * @deprecated
 */
export var cleanupResizeElements = 'cleanupResizeElements';
/**
 * @hidden
 * @deprecated
 */
export var afterKeyDown = 'afterKeyDown';
/**
 * @hidden
 * @deprecated
 */
export var updateValueOnIdle = 'updateValueOnIdle';
/**
 * @hidden
 * @deprecated
 */
export var documentClickClosedBy = 'documentClickClosedBy';
/**
 * @hidden
 * @deprecated
 */
export var showColorPicker = 'showColorPicker';
/**
 * @hidden
 * @deprecated
 */
export var showDropDown = 'showDropDown';
/**
 * @hidden
 * @deprecated
 */
export var closeTooltip = 'closeTooltip';
/**
 * @hidden
 * @deprecated
 */
export var autoResize = 'autoResize';
/**
 * @hidden
 * @deprecated
 */
export var onAIAssistant = 'onAIAssistant';
/**
 * @hidden
 * @deprecated
 */
export var menuItemselected = 'menuItemselected';
/**
 * @hidden
 * @deprecated
 */
export var menuBeforeOpen = 'menuBeforeOpen';
/**
 * @hidden
 * @deprecated
 */
export var menuBeforeClose = 'menuBeforeClose';
/**
 * @hidden
 * @deprecated
 */
export var selectionChangeMouseUp = 'selectionChangeMouseUp';
/**
 * @hidden
 * @deprecated
 */
export var blockEmptyNodes = "address:empty, article:empty, aside:empty, blockquote:empty,\n details:empty, dd:empty, div:empty, dl:empty, dt:empty, fieldset:empty, footer:empty,form:empty, h1:empty,\n h2:empty, h3:empty, h4:empty, h5:empty, h6:empty, header:empty, hgroup:empty, li:empty, main:empty, nav:empty,\n noscript:empty, output:empty, p:empty, pre:empty, section:empty, td:empty, th:empty";
/**
 * @hidden
 * @deprecated
 */
export var inlineEmptyNodes = "a:empty, abbr:empty, acronym:empty, b:empty, bdi:empty, bdo:empty, big:empty, button:empty,\ncanvas:empty, cite:empty, code:empty, data:empty, datalist:empty, del:empty, dfn:empty, em:empty, font:empty, i:empty, iframe:empty,\nins:empty, kbd:empty, label:empty, map:empty, mark:empty, meter:empty, noscript:empty, object:empty, output:empty, picture:empty, progress:empty,\nq:empty, ruby:empty, s:empty, samp:empty, script:empty, select:empty, slot:empty, small:empty, span:empty, strong:empty, strike:empty, sub:empty, sup:empty, svg:empty,\ntemplate:empty, textarea:empty, time:empty, u:empty, tt:empty, var:empty, wbr:empty";
/**
 * @hidden
 * @deprecated
 */
export var onHandleFontsizeChange = 'onHandleFontsizeChange';
/**
 * @hidden
 * @deprecated
 */
export var preventQuickToolbarClose = 'preventQuickToolbarClose';
/**
 * @hidden
 * @deprecated
 */
export var selectionChanged = 'selectionChanged';
/**
 * @hidden
 * @deprecated
 */
export var wordImporting = 'wordImporting';
/**
 * @hidden
 * @deprecated
 */
export var documentExporting = 'documentExporting';
